module.exports = __webpack_public_path__ + "img/return.182218e1.svg";